<template>
    <el-dialog title="更改文件归属来访" :visible.sync="isChangeBelongVisible" width="600px" height="300px" @close="BelongClose">
        <div class=" h-full">
            <div class="flex-grow mb-4 px-4 transition duration-300 ease-in-out">
                <div class="relative">
                    <el-input class="flex-grow p-2 focus:outline-none"
                              v-model="searchVisitorKey"
                              @input="handleSearchVisitor" placeholder="搜索来访者">
                        <template #prefix>
                            <i class="fa fa-search text-gray-800 p-4 pt-5"></i>
                        </template>
                    </el-input>
                </div>
            </div>
            <div class="overflow-y-auto h-[300px]">
                <div class="bg-transparent">
                    <div class="bg-transparent px-4" v-for="visitors in visitorShowList" :key="visitors.index">
                        <div class="px-4 flex justify-start">
                            <h3 class="text-l font-bold text-stone-700 ">{{ visitors.index }}</h3>
                        </div>
                        <div v-for="v in visitors.vinfos" :key="v.visitorid">
                            <a @click="afterChoiceVisitor(v)" class="block">
                                <div class="flex items-center bg-transparent rounded-full my-2 p-2 hover:bg-gray-100"
                                     :class="[  isSmallScreen ? 'flex flex-row' : '',
                                            { 
                                                'bg-sky-400': selectBelongId === v.visitorid, 
                                                'hover:bg-sky-300': selectBelongId === v.visitorid,
                                                'text-white': selectBelongId === v.visitorid, // 可选：添加文本颜色以提高对比度
                                            }]">
                                    <div class="v-avatar w-10 h-10 bg-blue-200 rounded-full flex items-center justify-center" :style="{ backgroundColor:v.color }">
                                        <span class="text-blue-600 text-lg">{{ v.visitorName.charAt(0) }}</span>
                                    </div>
                                    <div class="ml-2 flex flex-row">
                                        <div>
                                            <div class="text-base font-medium text-gray-500">{{ v.visitorName }}</div>
                                        </div>
                                        <div v-if="isSmallScreen">
                                            <div v-if="v.visitorid==curBelongIdIn" class="bg-blue-200 text-sm text-blue-600 p-1 ml-6 px-3 rounded-md" data-no-activator=""> 当前归属 </div>
                                        </div>
                                        <div v-else>
                                            <div v-if="v.visitorid==curBelongIdIn" class="bg-blue-200 text-sm text-blue-600 ml-6 p-1 px-3 rounded-md" data-no-activator=""> 当前归属 </div>
                                        </div>
                                    </div>

                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <template #footer>
            <div class="flex justify-evenly">
                <button type="button" class="flex items-center text-blue-600 px-6" @click="isVisitorVisible=true">
                    <i class="fa fa-user-plus" />
                    <span>新增来访者</span>
                </button>

                <el-button type="primary" @click="handleConfirm">确认 </el-button>
            </div>
            <AddVisitorDialog v-model="isVisitorVisible"   @addVConfirm="addVisitorConfirm"> </AddVisitorDialog>
        </template>
    </el-dialog>
</template>
<script>
    import axios from 'axios';
    import AddVisitorDialog from './AddVisitorDialog.vue'; 
    export default {
        components: {
            AddVisitorDialog,
        },
        props: {
            value: {
                type: Boolean,
                required: true,
            },
            curBelongIdIn: {
                type: Number,
                required: '',
            }
        },
        watch: {
            value(newValue) {
                this.isChangeBelongVisible = newValue;
                if (newValue) {
                    this.getAllVisitors();
                }
            },
        },
        data() {
            return {
                isChangeBelongVisible: this.value,
                timeout: null,
                selectBelongId: null,
                searchVisitorKey: "",
                isVisitorVisible: false,
                visitorList:[],
                form_addvisitor: {},
                visitorShowList: [],
                selectName:null,
            }
        },

        methods: {
            addVisitorConfirm(res) {
                console.log("22222222222222222");
                console.log(res);
                this.getAllVisitors();
            },
            afterChoiceVisitor(v) {
                console.log("visitorShowList");
                console.log(this.visitorShowList);
                console.log(v);
                this.selectName = v.visitorName;
                this.selectBelongId = v.visitorid;
                console.log('选中的ID:', this.selectBelongId); // 确认选中的ID
                console.log('条件是否满足:', this.selectBelongId === v.visitorid); // 确认条件是否满足
            },
            handleSearchVisitor() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.visitorFilter();
                }, 1000);
            },
            BelongConfirm() {
                //TODO 上送权限修改请求
                this.selectBelongId = null;
                this.isChangeBelongVisible = false;
                this.$emit('input', false);
            },
            BelongClose() {
                this.selectBelongId = null;
                this.isChangeBelongVisible = false;
                this.$emit('input', false);
            },
            closeDialog() {
                this.isVisitorVisible = false;
            },
            handleSelectVisitorChange(value) {
                var v;
                this.visitorList.forEach(group => {
                    // 筛选当前组中的 vinfos
                    const matchingVinfos = group.vinfos.filter(vinfo => vinfo.visitorName === value);
                    if (matchingVinfos.length > 0) {
                        v = matchingVinfos[0];
                        console.log("====选择匹配========");
                        console.log(v);
                    }
                });
                /*             this.form_addvisitor.visitorName = v.visitorName;
                             this.form_addvisitor.age = v.age;
                             this.form_addvisitor.gender = v.gender;
                             this.form_addvisitor.backgroundInfo = v.backgroundInfo;
                             this.form_addvisitor.symptoms = v.symptoms;
                             this.form_addvisitor.contact = v.contact;*/
            },
            addVisitorClose() {
                this.form_addvisitor = {
                    visitorName: '匿名',
                    gender: '',
                    age: '',
                    visitDate: '',
                    contact: '',
                    symptoms: '',
                    backgroundInfo: '',
                    useLanguage: '普通话',
                };
            },
            visitorFilter() {
                if (this.searchVisitorKey.trim() === '') {
                    this.visitorShowList = this.visitorList;
                } else {
                    this.visitorShowList = this.visitorList.map(visitor => {
                        return {
                            index: visitor.index,
                            vinfos: visitor.vinfos.filter(v => v.visitorName.includes(this.searchVisitorKey))
                        };
                    }).filter(visitor => visitor.vinfos.length > 0);
                }
            },
            assignColors() {
                this.visitorList.forEach(visitorGroup => {
                    visitorGroup.vinfos.forEach(visitor => {
                        if (!visitor.color) {
                            visitor.color = this.getRandomColor();
                        }
                    });
                });
            },
            async submitAddVisitorForm() {
                if (!this.submitAddVisitorFormCheck()) {
                    return;
                }
                const token = localStorage.getItem('token');
                if (!token) {
                    this.$message.error('请先登录！ ');
                    setTimeout(() => {
                        this.showLogin();
                    }, 2000);
                    return;
                }
                try {
                    const payload = {
                        name: this.form_addvisitor.visitorName,
                        age: this.form_addvisitor.age,
                        gender: this.form_addvisitor.gender,
                        visitDate: this.form_addvisitor.visitDate,
                        contact: this.form_addvisitor.contact,
                        symptoms: this.form_addvisitor.symptoms,
                        backgroundInfo: this.form_addvisitor.backgroundInfo,
                    };

                    const response = await axios.post('/api/addvisitor', payload, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        }
                    });
                    this.$message({
                        message: response.data.message,
                        type: response.data.type
                    });
                    this.isVisitorVisible = false;
                } catch (error) {
                    console.error('add failed:', error);
                    this.registrationMessage = 'add visitor failed. Please try again.';
                }
            },
            async getAllVisitors() {
                const token = localStorage.getItem('token');
                console.log(" getAllVisitors token " + token);
                if (!token) {
                    return;
                }
                try {
                    console.log( {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    });
                    const response = await axios.get('/api/getvisitors', {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        }
                    });
                    if (response.data.code == "00") {
                        console.log('Login successful:', response.data);
                        if (response.data.visitorList.length > 0) {
                            this.visitorList = response.data.visitorList;
                            console.log(this.visitorShowList);
                            this.assignColors();
                            this.visitorFilter();
                        }
                    } else {
                        this.$message({
                            message: response.data.message,
                            type: response.data.type,
                        });
                    }

                } catch (error) {
                    console.error('get visitors error:', error);
                    if (this.visitorTryTime > 0) {
                        this.visitorTryTime -= 1;
                    }
                   /* setTimeout(() => {
                        this.getAllVisitors();
                    }, 4 * 1000);*/
                }
            },
            getRandomColor() {
                // 生成较淡的随机颜色
                const r = Math.floor(Math.random() * 120); // 红色值
                const g = Math.floor(Math.random() * 120); // 绿色值
                const b = Math.floor(Math.random() * 120); // 蓝色值

                // 计算平均值以生成浅色
                const lightColor = `rgba(${Math.floor(r + 128)}, ${Math.floor(g + 128)}, ${Math.floor(b + 128)}, 0.4)`;
                return lightColor;
            },
            handleConfirm() {
                console.log("this.selectBelongId");
                console.log(this.selectBelongId);
                if (!this.selectBelongId) {
                    this.$message.info("请选择对应来访者，或退出！");
                    return;
                }
                console.log("select choice");
                console.log(this.selectBelongId);
                this.isChangeBelongVisible = false; // 关闭对话框
                this.$emit('confirm', { id: this.selectBelongId, vname: this.selectName }); 
            },
        },
        computed: {
            /*isChangeBelongVisible: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                },
            },*/
            allColors() {
                return this.visitorShowList.reduce((acc, visitor) => {
                    const color = visitor.vinfos.map(vinfo => vinfo.color);
                    return acc.concat(color);
                }, []);
            },
            allNames() {
                return this.visitorShowList.reduce((acc, visitor) => {
                    const names = visitor.vinfos.map(vinfo => vinfo.visitorName);
                    return acc.concat(names);
                }, []);
            },
        },
    };
</script>

<style>
</style>

